import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";

import moving from "../../assets/images/moving.jpg";
import storing from "../../assets/images/storing.jpg";
import clip from "../../assets/images/magal/clip.mp4";
import home from "../../assets/images/home-flipped.jpg";
import "./Home.css";

const Home = () => {
  // const [start, setStart] = useState(true)

  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView()
  //   setStart(false)
  // }, []);

  const servicesArr = [
    {
      header: "הובלה",
      img: moving,
      link: "/transport",
    },
    {
      header: "אחסנה",
      img: storing,
      link: "/storage",
    },
  ];

  return (
    <>
      <div className="home_banner">
        <img src={home} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הובלה ואחסנה </h1>
            <div>כל הפתרונות עבורך במקום אחד</div>
            <div>שירות מקצועי ואמין ללא פשרות</div>
            <div>
              <h6>א.א מובילים & ב.ר שירותי אחסון</h6>
            </div>
          </div>
          <div className="btnDiv">
            <MainBtn text="הובלה" link="/transport#top" />
            <MainBtn text="אחסנה" link="/storage#top" isLight={true} />
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">השירותים שלנו</h1>
        <div className="services">
          {servicesArr.map((el, i) => {
            return (
              <Link to={el.link} key={i}>
                <div className="service">
                  <img src={el.img} alt="" />
                  <h1>{el.header}</h1>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="about">
        <h1 className="homeTitle">אודותינו</h1>
        <div className="clipWrapper">
          <video
            className="clip"
            playsInline
            src={clip}
            autoPlay={true}
            muted={true}
            controls
          />
        </div>
      </div>

      {/* <div className="blogDiv">
        <h1 className="homeTitle">הבלוג שלנו</h1>
        <div className="postsDiv">
          {blogArr.map((el, i) => {
            return (
              <div className="post">
                <img src={el.img} />
                <h5>{el.title}</h5>
              </div>
            )
          })}
        </div>
        <div className="blogBtn">
          <MainBtn text='לכל הכתבות' link='/blog' />
        </div>
      </div> */}

      <Reviews />
      <Footer isContact={true} />
    </>
  );
};

export default Home;
